import { Box, Button, Checkbox, Heading, Image, Input,  Text, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useContext } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { AuthContext } from '../Context/AuthContext'

function Login() {
    const {data,setUsername,isAuth,setIsAuth} = useContext(AuthContext)
    const [loginData, setLoginData] = useState([])
    const navigate = useNavigate()
    function onChange(e){
        const {value,name} = e.target
        setLoginData({
            ...loginData,
            [name]:value
        })
    }
    function onSubmit(){
        let flag = false
        for(let i=0; i<data.length; i++){
            if(data[i].username===loginData.username && data[i].password===loginData.password){
                setIsAuth(!isAuth)
                setUsername(data[i].username)
                flag = true
                break;
            }
        }
        flag ? navigate("/") : alert("You Entered incorrect Username or Password.")
    }
   
  return (
    <>
        <Box display="flex" >
            <Box w="35%" >
                <Box p="1rem">
                    <Image width="40px" src="https://login.mailchimp.com/release/1.1.1e50f5e5c68898d541162415193a0da75d0ce183c/images/brand_assets/logos/mc-freddie-dark.svg"/>
                </Box>
                <Box  m="2rem 2rem 0rem 3rem" textAlign="left" >
                    <VStack spacing={6} align="stretch">
                        <Box>
                            <Heading fontWeight="400">Log In</Heading>
                            <Text>Nedd a Mailchimp account? <Button variant="link" colorScheme="teal"><NavLink to="/signup">Create an account</NavLink></Button></Text>
                        </Box>
                        <Box textAlign="left">
                            <label style={{fontWeight:"bold"}}>
                                Username
                                <Input mt="10px" onChange={onChange} borderColor="black" name="username" value={loginData.username} type="text" />
                            </label>
                        </Box>
                        <Box textAlign="left">
                            <label  style={{fontWeight:"bold"}}>
                                Password 
                                <Input  mt="10px" onChange={onChange} borderColor="black" name="password" value={loginData.password} type="password" />
                            </label>
                        </Box>
                        <Box>
                            <Button w="100%" onClick={()=>onSubmit()} variant="solid" colorScheme="teal" color="white">Log In</Button>
                        </Box>
                        <Box textAlign="center">
                        <Checkbox borderColor="teal" > Keep me logged in</Checkbox>
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="space-around">
                            <Button textDecoration="underline"  variant="link" colorScheme="teal">Forgot Username?</Button>
                            <Button  textDecoration="underline" variant="link" colorScheme="teal">Forgot Password?</Button>
                        </Box>
                    </VStack>
                </Box>
            </Box>
            <Box  w="65%">
                <Image width="100%" height="100%"src="https://user-images.githubusercontent.com/99709824/180207102-21bb0b0f-5472-40cf-910b-80e3d714c37c.png"/>
            </Box> 
        </Box>        
    </>
  )
}

export default Login